import { GetDepositPromotionNamesForSelectorResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'
import { getDepositPromotionNamesForBrokeNotification } from '../../services'

export default function useQueryGetDepositPromotionNamesForBrokeNotification(
	props?: UseBaseQueryOptions<GetDepositPromotionNamesForSelectorResponse>,
) {
	return useQuery({
		queryKey: [
			DepositPromotionQueryKeys.GetDepositPromotionNamesForBrokeNotification,
		],
		queryFn: () => getDepositPromotionNamesForBrokeNotification(),
		...props,
	})
}
